export class BankTranactionModel {
    refId: string;
    bankOrderId: string;
    orderId: string;
    sendToBankUrl: string;
    sendMethod: string;
}